import { render, staticRenderFns } from "./FacebookAdsSummary.vue?vue&type=template&id=13e61925&scoped=true&"
import script from "./FacebookAdsSummary.vue?vue&type=script&lang=js&"
export * from "./FacebookAdsSummary.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAdsSummary.vue?vue&type=style&index=0&id=13e61925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e61925",
  null
  
)

export default component.exports